module.exports = __webpack_public_path__ + "media/images/icon_hobby-bfc5f9b7c208a38694a64911bc4e4990.svg";